import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useMemo, useState } from 'react';

/** Get the size of the element. */
export function useElementSize() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    element = _useState2[0],
    setElement = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    width = _useState4[0],
    setWidth = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    height = _useState6[0],
    setHeight = _useState6[1];
  useEffect(function () {
    if (!element) {
      return;
    }

    // Do no use here ResizeObserverEntry.contentRect as it is only a content size (without padding and border)
    // and we need the size of the whole element.
    var updateSize = function updateSize() {
      var _element$getBoundingC = element.getBoundingClientRect(),
        width = _element$getBoundingC.width,
        height = _element$getBoundingC.height;
      setWidth(width);
      setHeight(height);
    };
    var resizeObserver = new ResizeObserver(updateSize);
    resizeObserver.observe(element);
    return function () {
      resizeObserver.disconnect();
    };
  }, [element]);
  return useMemo(function () {
    return [setElement, {
      width: width,
      height: height
    }];
  }, [width, height]);
}